import { render, staticRenderFns } from "./ProductoAlmacenKardex.vue?vue&type=template&id=6ce490e2&scoped=true&"
import script from "./ProductoAlmacenKardex.vue?vue&type=script&lang=js&"
export * from "./ProductoAlmacenKardex.vue?vue&type=script&lang=js&"
import style0 from "./ProductoAlmacenKardex.vue?vue&type=style&index=0&id=6ce490e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce490e2",
  null
  
)

export default component.exports